// ExportSiteDXF.tsx — Export full site plan to DXF R2000

import DialogBase from './DialogBase';
import { useStore } from '../store/useStore';
import { buildSiteDXFString, siteDXFFilename } from '../utils/dxfExport';
import { gatedDownload } from '../utils/exportGateway';
import { useEntitlement } from '../auth/AuthProvider';

const encoder = new TextEncoder();

export default function ExportSiteDXF() {
  const project = useStore(s => s.project);
  const { refresh } = useEntitlement();

  async function handleExport() {
    if (!project) return;
    const res = await gatedDownload({
      artifact: 'dxf',
      filename: siteDXFFilename(project),
      mimeType: 'application/dxf',
      preflight: () => {
        if (!project.site) {
          throw new Error('No site plan configured. Open Site › Site Setup first.');
        }
      },
      build: () => encoder.encode(buildSiteDXFString(project)),
    });
    if (res.ok) {
      refresh();
    } else if (res.reason === 'preflight') {
      alert(res.message ?? 'Cannot export site DXF.');
    } else if (res.reason === 'producer_error') {
      alert(res.message ?? 'Site DXF export failed.');
    } else if (res.reason === 'network') {
      alert(`Export failed: ${res.message ?? 'network error'}`);
    }
  }

  return (
    <DialogBase
      title="Export Site Plan DXF"
      okLabel="Export"
      onOk={() => { void handleExport(); }}
    >
      {project?.site ? (
        <>
          <p className="dialog-info">
            Exporting site plan for <strong>{project.site.projectName || project.name}</strong>.
          </p>
          <p className="dialog-info">
            {project.site.panels.length} panel placement(s) included.
          </p>
          <p className="dialog-info">
            Layers: SITE, GRID, NOTES
          </p>
          <p className="dialog-info">
            <em>Costs 1 token.</em>
          </p>
        </>
      ) : (
        <p className="dialog-warning">No site plan configured. Open Site › Site Setup first.</p>
      )}
    </DialogBase>
  );
}
